// Centralized Pricing Configuration
// Update prices here - they will reflect across the entire site

export const pricingConfig = {
  currency: {
    code: "GBP",
    symbol: "£",
    locale: "en-GB"
  },
  
  // Launch settings
  launchMode: {
    enabled: true,
    endDate: null,
    badge: "Launch Price",
    standardBadge: "Standard Price",
    foundingOfferLimit: 26, // First 26 users (for 2026!)
    foundingOfferClaimed: 0 // Track how many claimed
  },

  // Managerial Companion availability
  companion: {
    available: true,
    weekly: {
      price: 7.99,
      period: "week",
      label: "Weekly",
      description: "£7.99/week after 5-day free trial",
      trialDays: 5,
      monthlyEquivalent: 34.63  // ~£7.99 * 4.33 weeks
    },
    monthly: {
      price: 19.00,
      period: "month",
      label: "Monthly",
      description: "£19/month, cancel anytime"
    },
    annual: {
      price: 190.00,
      period: "year",
      label: "Annual",
      description: "£190/year (save £38)",
      savings: 38,
      savingsPercent: 17
    }
  },

  // Products configuration
  products: {
    // ============================================================
    // BOOK 1: First Steps (Available until March 16, 2026)
    // ============================================================
    
    // Option 1: Book Only — NOW KINDLE EXCLUSIVE
    singleBook: {
      id: "single-book",
      stripeProductId: "book1",
      name: "Book 1: First Steps",
      shortName: "Book Only",
      description: "30 daily lessons to build your leadership foundations",
      purchaseType: "one-time",
      includes: [
        "30 daily leadership lessons",
        "Practical exercises for each day",
        "Lifetime access with free updates",
        "Never renews, no ongoing cost"
      ],
      excludes: [],
      standardPrice: 6.99,
      launchPrice: 6.99,
      priceType: "one-off",
      recommended: false,
      popular: false,
      badge: "On Amazon",
      purchaseLink: "#single-book",
      showCheckoutUpsell: false,
      available: false,
      availabilityType: "external",
      kindleExclusiveUntil: "2026-06-14",
      amazonLinks: {
        kindle: "https://www.amazon.co.uk/dp/B0GKPPK9M8",
        paperback: "https://www.amazon.co.uk/dp/B0GKPPK9M8"
      }
    },

    // Option 2: Book + Companion Bundle — DEACTIVATED
    bookWithAI: {
      id: "book-ai-bundle",
      stripeProductId: "book1_ai_bundle",
      name: "Book 1 + Companion",
      shortName: "Book + Companion",
      description: "Book (one-time) plus Managerial Companion subscription",
      purchaseType: "book-plus-subscription",
      includes: [],
      excludes: [],
      bookPrice: 6.99,
      subscriptionMonthly: 7.50,
      subscriptionAnnual: 75.00,
      standardPrice: 6.99,
      launchPrice: 6.99,
      priceType: "bundle-free-trial",
      priceDisplay: "£6.99 book + Companion subscription",
      recommended: false,
      popular: false,
      badge: "Unavailable",
      purchaseLink: "#book-ai-bundle",
      foundingAccess: true,
      allowBillingChoice: true,
      available: false,
      availabilityType: "unavailable"
    },

    // ============================================================
    // BOOK 2: Stepping Up (Available from March 16, 2026)
    // ============================================================
    
    book2: {
      id: "book2",
      stripeProductId: "book2",
      name: "Book 2: Stepping Up",
      fullName: "Stepping Up: Turning Peer Relationships into Leadership Success",
      shortName: "Book 2",
      description: "Navigate the transition from peer to leader",
      purchaseType: "one-time",
      includes: [
        "30 daily lessons for new managers",
        "Navigate former peer relationships",
        "Build leadership credibility",
        "Lifetime access with free updates"
      ],
      excludes: [],
      standardPrice: 6.99,
      launchPrice: 6.99,
      priceType: "one-off",
      recommended: true,
      popular: false,
      badge: "NEW",
      purchaseLink: "#book2",
      showCheckoutUpsell: false,
      available: true,
      availabilityType: "direct"
    },

    book2WithAI: {
      id: "book2-ai-bundle",
      stripeProductId: "book2_ai_bundle",
      name: "Book 2 + Companion",
      shortName: "Book 2 + Companion",
      description: "Book 2 plus Managerial Companion subscription",
      purchaseType: "book-plus-subscription",
      includes: [
        "Book 2: £6.99 (one-time, keep forever)",
        "First month Companion FREE",
        "Then £7.50/month or £75/year",
        "Founding Access benefits"
      ],
      excludes: [],
      bookPrice: 6.99,
      subscriptionMonthly: 7.50,
      subscriptionAnnual: 75.00,
      standardPrice: 6.99,
      launchPrice: 6.99,
      priceType: "bundle-free-trial",
      priceDisplay: "£6.99 book + Companion subscription",
      recommended: false,
      popular: true,
      badge: "Best Value",
      purchaseLink: "#book2-ai-bundle",
      foundingAccess: true,
      allowBillingChoice: true,
      available: false, // Set to true on March 16
      availabilityType: "direct",
      launchDate: "2026-03-16"
    },

    // ============================================================
    // SERIES BUNDLES — DEACTIVATED (Book 1 is Kindle Select exclusive)
    // ============================================================

    // Full Series Bundle (books only)
    seriesBundle: {
      id: "series-bundle",
      stripeProductId: "series_bundle",
      name: "Full Series (All 8 Books)",
      shortName: "All Books",
      description: "All 8 books, one-time purchase",
      purchaseType: "one-time",
      includes: [],
      excludes: [],
      standardPrice: 39.99,
      launchPrice: 39.99,
      priceType: "one-off",
      savings: "Save ~30% vs individual",
      recommended: false,
      popular: false,
      purchaseLink: "#series-bundle",
      available: false,
      availabilityType: "unavailable",
      hiddenReason: "kindle_select"
    },

    // Full Series + AI (Founding Offer)
    seriesWithAI: {
      id: "series-ai-founding",
      stripeProductId: "series_bundle_ai",
      name: "Full Series + Companion",
      shortName: "Series + Companion",
      description: "All books (keep forever) + 12 months Companion",
      purchaseType: "founding-bundle",
      includes: [
        "All 8 books (one-time, yours forever)",
        "12 months Companion subscription",
        "Founding Access priority features"
      ],
      excludes: [],
      standardPrice: 99.00,
      launchPrice: 79.00,
      priceType: "founding",
      recommended: false,
      popular: false,
      badge: "Founding Offer",
      purchaseLink: "#series-ai",
      foundingAccess: true,
      available: false,
      availabilityType: "unavailable",
      hiddenReason: "kindle_select",
      foundingOffer: {
        enabled: true,
        price: 79.00,
        standardPrice: 99.00,
        limit: 26,
        breakdown: {
          books: "All 8 books (keep forever with free updates)",
          companion: "12 months Companion subscription",
          renewal: "Companion renews at £75/year; books yours forever"
        }
      }
    },

    // ============================================================
    // OLD COMPANION-ONLY SUBSCRIPTIONS — REPLACED BY TIERS
    // ============================================================

    // Companion-only Monthly — DEACTIVATED
    companionMonthly: {
      id: "companion-monthly",
      stripeProductId: "ai_monthly",
      name: "Companion Monthly",
      shortName: "Monthly",
      description: "Flexible month-to-month access",
      purchaseType: "subscription",
      includes: [
        "Unlimited AI-powered reflections",
        "Personalised management coaching",
        "Pattern insights across your journey",
        "Cancel anytime, no commitment"
      ],
      standardPrice: 7.50,
      launchPrice: 7.50,
      priceType: "monthly",
      billingInterval: "month",
      recommended: false,
      popular: false,
      purchaseLink: "#companion-monthly",
      available: false,
      availabilityType: "unavailable"
    },

    // Companion-only Annual — DEACTIVATED
    companionAnnual: {
      id: "companion-annual",
      stripeProductId: "ai_annual",
      name: "Companion Annual",
      shortName: "Annual",
      description: "Best rate — save £15 per year",
      purchaseType: "subscription",
      includes: [],
      standardPrice: 75.00,
      launchPrice: 75.00,
      priceType: "annual",
      billingInterval: "year",
      recommended: false,
      popular: false,
      savings: 15,
      savingsPercent: 17,
      purchaseLink: "#companion-annual",
      available: false,
      availabilityType: "unavailable"
    }
  },

  // Checkout upsell configuration — DEACTIVATED (old Book 1 flow)
  checkoutUpsell: {
    enabled: false,
    promoPrice: 3.50,
    regularMonthly: 7.50,
    regularAnnual: 75.00,
    headline: "Special Offer: Add Managerial Companion",
    benefits: [
      "Contextual advice specific to your situation",
      "Unlimited web-based reflections",
      "Pattern insights showing your growth over time",
      "20 email reflections per week for on-the-go support"
    ],
    allowBillingChoice: true
  },

  // Founding Access bonus
  foundingBonus: {
    enabled: true,
    name: "Founding Access",
    description: "Exclusive bonus for early supporters",
    includes: [
      "Priority beta access to new features",
      "Direct feedback channel",
      "Influence future improvements"
    ],
    appliesTo: ["book-ai-bundle", "series-ai-founding"]
  },

  // Display settings
  display: {
    showComparisonTable: true,
    highlightRecommended: true,
    showSavings: true,
    showRenewalPrice: true,
    defaultBillingFrequency: "annual", // Default to annual (shows savings)
    ctaText: {
      "one-off": "Get Started",
      "annual": "Start Learning",
      "monthly": "Subscribe",
      "bundle-free-trial": "Get Started",
      "founding": "Claim Founding Access"
    }
  }
};

// Helper functions

export const formatPrice = (price) => {
  return new Intl.NumberFormat(pricingConfig.currency.locale, {
    style: 'currency',
    currency: pricingConfig.currency.code,
    minimumFractionDigits: 2
  }).format(price);
};

export const getActivePrice = (product) => {
  if (pricingConfig.launchMode.enabled && product.launchPrice) {
    return product.launchPrice;
  }
  return product.standardPrice;
};

export const isLaunchPrice = (product) => {
  return pricingConfig.launchMode.enabled && 
         product.launchPrice && 
         product.launchPrice !== product.standardPrice;
};

export const getPriceLabel = (product) => {
  switch (product.priceType) {
    case 'one-off':
      return 'one-time';
    case 'monthly':
      return '/month';
    case 'annual':
      return '/year';
    case 'bundle-free-trial':
      return 'first month';
    case 'founding':
      return 'first year';
    default:
      return '';
  }
};

export const getProductsForDisplay = () => {
  const { singleBook, bookWithAI, book2, book2WithAI, seriesBundle, seriesWithAI } = pricingConfig.products;
  // Filter to only available products
  const allProducts = [singleBook, bookWithAI, book2, book2WithAI, seriesBundle, seriesWithAI];
  return allProducts.filter(p => p.available !== false && p.availabilityType !== 'unavailable');
};

export const getPrimaryProducts = () => {
  const { singleBook, bookWithAI, book2, book2WithAI } = pricingConfig.products;
  // Return Book 1 or Book 2 based on availability
  const book1Products = [singleBook, bookWithAI].filter(p => p.available !== false);
  const book2Products = [book2, book2WithAI].filter(p => p.available !== false);
  
  // Prefer Book 2 if available, otherwise Book 1
  if (book2Products.length > 0) {
    return book2Products;
  }
  return book1Products;
};

export const getBook1Products = () => {
  const { singleBook, bookWithAI } = pricingConfig.products;
  return [singleBook, bookWithAI];
};

export const getBook2Products = () => {
  const { book2, book2WithAI } = pricingConfig.products;
  return [book2, book2WithAI];
};

export const getAvailableBookProducts = () => {
  const book1 = getBook1Products().filter(p => p.available !== false);
  const book2 = getBook2Products().filter(p => p.available !== false);
  return [...book1, ...book2];
};

export const getSecondaryProducts = () => {
  const { seriesBundle, seriesWithAI } = pricingConfig.products;
  // Filter by availability
  return [seriesBundle, seriesWithAI].filter(p => p.available !== false);
};

export const getCompanionStandaloneProducts = () => {
  const { companionMonthly, companionAnnual } = pricingConfig.products;
  return [companionMonthly, companionAnnual];
};

export const getCheckoutUpsellConfig = () => {
  return pricingConfig.checkoutUpsell;
};

export const getCompanionPricing = () => {
  return pricingConfig.companion;
};

export const isCompanionAvailable = () => {
  return pricingConfig.companion.available;
};

// Check if a product is external (Amazon only)
export const isExternalProduct = (product) => {
  return product.availabilityType === 'external';
};

// Check if Book 1 is in Kindle Select period
export const isBook1KindleExclusive = () => {
  const { singleBook } = pricingConfig.products;
  return singleBook.availabilityType === 'external' || singleBook.available === false;
};

// Get Amazon links for a product
export const getAmazonLinks = (product) => {
  return product.amazonLinks || {};
};

// Legacy alias for backwards compatibility
export const isAIAvailable = isCompanionAvailable;

export default pricingConfig;
